import { get } from '@core/Services/ApiService'

interface CognitoAuthenticationResponse {
  expiresAt: string
  expiresIn: number
}

let isAuthenticatedUntil: Date | null = null

export async function isCognitoUserAuthenticated(ignoreCache?: boolean) {
  if (isAuthenticatedUntil && ignoreCache !== true) {
    if (isAuthenticatedUntil.getTime() > Date.now()) {
      return true
    }
  }

  try {
    const response = await fetchCognitoIsAuthenticated()

    if (response.expiresIn > 0) {
      // if the user is authenticated, it returns how long until the token expires
      // we want to store this result for 15minutes or until the expiry time
      // whatever is shorter
      const expiresInSeconds = (response.expiresIn ?? 0) - 2 * 60
      const isAuthenticatedDurationInSeconds = Math.min(15 * 60, expiresInSeconds)
      isAuthenticatedUntil = new Date(Date.now() + isAuthenticatedDurationInSeconds * 1000)
      return true
    } else {
      return false
    }
  } catch {
    isAuthenticatedUntil = null
    return false
  }
}

export async function fetchCognitoIsAuthenticated() {
  return await get<CognitoAuthenticationResponse>({
    url: '/api/mfa/is-authenticated',
  })
}

export class CognitoUnauthorizedError extends Error {
  constructor(message?: string) {
    super(message ? `User is unauthorized (${message})` : 'User is unauthorized')
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
